import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { PATA_PAY_FEATURES_CONFIG } from './pataPayFeatures.config';
import { BackgroundColor, ConditionsContainer, TilesContainer } from './pataPayFeatures.styled';
import TopFeatureTile from './topFeatureTile';

const PataPayFeatureTitle = () => {
  return (
    <TextWithHighlight>
      <h2>Why PataPay?</h2>
    </TextWithHighlight>
  );
};

export function PataPayFeatures() {
  return (
    <BackgroundColor>
      <WidthContainer noBackground>
        <SectionContainer title={PataPayFeatureTitle}>
          <TilesContainer>
            {PATA_PAY_FEATURES_CONFIG.map((tile) => (
              <TopFeatureTile title={tile.title} description={tile.description} icon={tile.icon} />
            ))}
          </TilesContainer>
        </SectionContainer>
        <ConditionsContainer>
          * excluding VAT
        </ConditionsContainer>
      </WidthContainer>
    </BackgroundColor>
  );
}
